<!--
  Component: NotAuthorized

  Component for displaying different Not Authorized messages, based on
  authorization type.

  Notes:
  - Invalid/no auth type specified will have generic message only

  Props:
  - authType - type to determine message displayed, following are valid values:
    - student-profile
-->

<template>
  <div :class="['not-authorized',authType]">
    <template v-if="authType==='student-profile'">
      <p>You are not authorized to view this report.</p>
      <p>School staff, superintendent team staff, and central staff with access to <LinkExternalUrl url="https://wiki.nycenet.edu/display/NSA/Access+to+Student+Profile">Student Profile</LinkExternalUrl> can view this report.</p>
      <p>If you believe you should have access but are unable to view this report, use the following contacts to request access:
        <ul>
          <li>Schools should contact their <LinkExternalUrl url="https://sites.google.com/schools.nyc.gov/edudirectory/home">academic policy, performance, and assessment (APPA) specialist</LinkExternalUrl>.</li>
          <li>Superintendent team staff should contact <a href="mailto:oaps@schools.nyc.gov">oaps@schools.nyc.gov</a>.</li>
          <li>Central staff should submit the <LinkExternalUrl url="https://forms.office.com/Pages/ResponsePage.aspx?id=tyxJGEXvYUWFcQxC5fesB-_mEUVV_GxItUeFHo_GhEhUNk5YQ0s4VkdQMUZGVjBJWElQUjBVTEhOTyQlQCN0PWcu">Student Profile Access Form</LinkExternalUrl>.</li>
          <li>Charter school staff should submit a ticket at <LinkExternalUrl url="http://charterschools.mojohelpdesk.com/">charterschools.mojohelpdesk.com</LinkExternalUrl>.</li>
        </ul>
      </p>
    </template>
    <template v-else>Not authorized</template>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import LinkExternalUrl from '@/components/LinkExternalUrl'

@Component({
  props: {
    authType: String
  },
  components: {
    LinkExternalUrl
  }
})
export default class NotAuthorized extends Vue {
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/NotAuthorized.vue